import { css } from '@emotion/react';

import { colors, gridPadding } from 'styles/theme';
import { mobileOnly, tabletUp } from 'styles/utils';

import Text from 'components/shared/Text/Text';
import Flexbox from 'components/shared/Flexbox/Flexbox';
import Picture from 'components/shared/Picture/Picture';
import Button from 'components/shared/Button/Button';
import Shape from 'components/shared/Shape/Shape';

const pageCss = css`
  position: relative;
  overflow: hidden;
  height: 100vh;
`;

const flexboxCss = css`
  ${mobileOnly} {
    flex-direction: column-reverse;
  }

  ${tabletUp} {
    height: 58vw;
    max-height: 745px;
  }
`;

const textColCss = css`
  ${mobileOnly} {
    max-width: 400px;
    margin: 0 auto;
    text-align: center;
  }

  ${tabletUp} {
    display: inline-flex;
    flex-direction: column;
    flex-basis: 473px;
    padding-right: 35px;
    justify-content: center;
  }
`;

const text2Css = css`
  &.MuiTypography-root {
    ${mobileOnly} {
      margin-top: 53px;
      margin-bottom: 29px;
    }

    ${tabletUp} {
      margin-top: 47px;
      margin-bottom: 35px;
    }
  }
`;

const pictureColCss = css`
  ${mobileOnly} {
    text-align: center;
  }

  ${tabletUp} {
    flex-basis: 50%;
    flex-grow: 1;
  }
`;

const pictureCss = css`
  width: 100%;

  ${mobileOnly} {
    max-width: 203px;
  }
`;

const pageContainerCss = css`
  max-width: 1070px;
  margin: 0 auto;
  padding-left: ${gridPadding}px;
  padding-right: ${gridPadding}px;
`;

const shape1MobileCss = css`
  right: -20px;
  top: 76px;
`;

const shape2MobileCss = css`
  right: -125px;
  top: 100px;
`;

const shape1DesktopCss = css`
  right: -100px;
  top: 174px;
`;

const shape2DesktopCss = css`
  right: -256px;
  top: 230px;
`;

function PageNotFound() {
  return (
    <div css={pageCss}>
      <div css={pageContainerCss}>
        <Flexbox css={flexboxCss}>
          {/* Text */}
          <div css={textColCss}>
            <Text
              mobileOnly={6}
              tabletUp={8}
              desktopUp={9}
              fontWeight={500}
              color={colors.darkPurple}
            >
              Oops
            </Text>
            <Text mobileOnly={2.6} tabletUp={2.6} desktopUp={3.6}>
              Looks like you caught us with our pants down…
            </Text>
            <Text fontSize={1.8} desktopUp={2.4} css={text2Css}>
              This page doesn’t exist but we can help you get back to our
              homepage
            </Text>
            <div>
              <Button href="/">Go to homepage</Button>
            </div>
          </div>

          {/* Image */}
          <div css={pictureColCss}>
            <Picture
              path="female-seated-toilet@2x-min.jpg"
              alt=""
              css={pictureCss}
            />
          </div>
        </Flexbox>
      </div>

      {/* Mobile shapes */}
      <Shape
        variant="circle"
        color="purple"
        size="sm"
        mobile
        css={shape1MobileCss}
      />
      <Shape
        variant="pill"
        color="pale"
        size="md"
        mobile
        css={shape2MobileCss}
      />

      {/* Desktop shapes */}
      <Shape
        variant="pill"
        color="purple"
        size="md"
        desktop
        css={shape1DesktopCss}
      />
      <Shape
        variant="pill"
        color="pale"
        size="xl"
        desktop
        css={shape2DesktopCss}
      />
    </div>
  );
}

export default PageNotFound;
